import { render, staticRenderFns } from "./organizationTree.vue?vue&type=template&id=52b349e4&scoped=true&"
import script from "./organizationTree.vue?vue&type=script&lang=ts&"
export * from "./organizationTree.vue?vue&type=script&lang=ts&"
import style0 from "./organizationTree.vue?vue&type=style&index=0&id=52b349e4&lang=scss&scoped=true&"
import style1 from "./organizationTree.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b349e4",
  null
  
)

export default component.exports